import React from 'react';
import { Typography } from '@mui/material';
import { floor } from 'lodash';
import { IPack } from '../../../../@types/model/masterData/pack/pack';

interface IPackSummaryProps {
    selectedPack : IPack;
}

const PackSummary = (props : IPackSummaryProps) => {
    /*================================================================================================================
     *                                                  Queries
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    const getNumberOfObjects = (isBottom : boolean) => {
        let count = 0;
        const children = [];

        if (!props.selectedPack.noUnitsPerCarton) {
            return;
        }
        if (isBottom) {
            count = props.selectedPack.noUnitsPerCarton % 2 === 0 ? props.selectedPack.noUnitsPerCarton / 2 : props.selectedPack.noUnitsPerCarton / 2;
        } else {
            count = floor(props.selectedPack.noUnitsPerCarton / 2);
        }
        for (let i = 0; i < count; i++) {
            let value = props.selectedPack.unitGrossWeight ? props.selectedPack.unitGrossWeight * 100 : 0;
            if (value % 1) {
                value = parseFloat(value.toFixed(2));
            }

            children.push(
                <div className={'flx1 p5 ml5 mr5 jcc aic bcs br5 h30'}>
                </div>,
            );
        }
        return children;
    };

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div className={'flx1 fdc ml10 mr10'}>
            <div className={'fdr hfill wfill jcc aic'}>
                <div className={'fdr wfill aife jcfe pr10 posr'} >
                    <img src={`${ASSET_BASE}/assets/images/pallet_image.svg`} />
                    <div className={'posa post50 w427'}>
                        <div className={'fdr pl20 pr20'}>
                            {getNumberOfObjects(false)}
                        </div>
                    </div>
                    <div className={'posa post95 w427'}>
                        <div className={'fdr pl20 pr20'}>
                            {getNumberOfObjects(true)}
                        </div>
                    </div>
                </div>
                <div className={'w10'}/>
                <div className={'fdr wfill pl10'}>
                    <div className={'fdc jcc aic'}>
                        <Typography>Total Cartons on pallet:</Typography>
                        <div className='h30 br5 pl10 pr10 jcc aic mt10 mb20 fw500 cw bcp'>{props.selectedPack.noCartons ? props.selectedPack.noCartons : 0}</div>
                        <Typography>Weight per inner (g):</Typography>
                        <div className='h30 br5 pl10 pr10 jcc aic mt10 mb20 fw500 bcs'>{props.selectedPack.unitGrossWeight ? (props.selectedPack.unitGrossWeight * 100).toFixed(2) : 0}</div>
                    </div>
                    <div className={'fdc jcc aic'}>
                        <Typography>Total inners per carton:</Typography>
                        <div className='h30 br5 pl10 pr10 jcc aic mt10 mb20 fw500 bcs'>{props.selectedPack.noUnitsPerCarton ? props.selectedPack.noUnitsPerCarton : 0}</div>
                        <Typography>Total inners weight per carton (kg):</Typography>
                        <div className='h30 br5 pl10 pr10 jcc aic mt10 mb20 fw500 cw bcp'>{(props.selectedPack.unitGrossWeight && props.selectedPack.noUnitsPerCarton) ? (props.selectedPack.unitGrossWeight * props.selectedPack.noUnitsPerCarton).toFixed(2) : 0}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PackSummary;
